export const FETCH_INDEXES_REQUEST = "FETCH_INDEXES_REQUEST";
export const FETCH_INDEXES_SUCCESS = "FETCH_INDEXES_SUCCESS";
export const FETCH_INDEXES_FAILURE = "FETCH_INDEXES_FAILURE";

export const FETCH_ANNOUNCEMENTS_REQUEST = "FETCH_ANNOUNCEMENTS_REQUEST";
export const FETCH_ANNOUNCEMENTS_SUCCESS = "FETCH_ANNOUNCEMENTS_SUCCESS";
export const FETCH_ANNOUNCEMENTS_FAILURE = "FETCH_ANNOUNCEMENTS_FAILURE";

export const SET_INDEXES = "SET_INDEXES";
export const SET_SELECTED_INDEX = "SET_SELECTED_INDEX";
export const SET_SELECTED_SUB_INDEX = "SET_SELECTED_SUB_INDEX";
export const SET_DEFAULT_INDEXES = "SET_DEFAULT_INDEXES";
export const SET_INDEX_KEY_AND_VALUE = "SET_INDEX_KEY_AND_VALUE";

export const UPDATE_HEADER_INDEX_KEY_AND_VALUE = "UPDATE_HEADER_INDEX_KEY_AND_VALUE"

export const SET_DEEPSEARCH_MODE = "SET_DEEPSEARCH_MODE";

export const SET_DEEPSEARCH_MODE_FALSE = "SET_DEEPSEARCH_MODE_FALSE";

export const SET_USE_ONLY_EXTERNAL_DOCUMENTS = "SET_USE_ONLY_EXTERNAL_DOCUMENTS";

export const SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE = "SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE";

export const HAS_EXTERNAL_UPLOADED_DOCUMENTS = "HAS_EXTERNAL_UPLOADED_DOCUMENTS";